import { Box } from '@change-corgi/design-system-legacy/layout';

import { SECTION_ID_MAPPING, useScrollToSection } from '../../hooks/useScrollToSection';
import { LegislativeBodiesContainer } from '../decisionMakersLegislativeBodies/LegislativeBodiesContainer';
import { ScrollTrackingWaypointContainer } from '../ScrollTrackingWaypoint';

import { useDecisionMakerSection } from './hooks/useDecisionMakerSection';

const ScrollTracking: React.FC = () => {
	return <ScrollTrackingWaypointContainer name="petition_details_decision_maker_section_view" />;
};

export const DecisionMakerSection: React.FC = () => {
	const {
		data: { showDMSection },
	} = useDecisionMakerSection();

	const {
		data: { refs },
	} = useScrollToSection();

	if (!showDMSection) return null;

	return (
		<div id={SECTION_ID_MAPPING.DECISION_MAKERS} ref={refs[SECTION_ID_MAPPING.DECISION_MAKERS]}>
			<ScrollTracking />
			<Box mx={[-16, 0]}>
				<LegislativeBodiesContainer />
			</Box>
		</div>
	);
};
